import React, { Component, Fragment } from 'react'
import { observer } from 'mobx-react'
import { HeaderView } from '@merchant-backend/common-components'
import Store from './store'
import styles from './style.module.less'

@observer
export default class extends Component {
  constructor(props) {
    super(props)
    const {
      params: { id }
    } = this.props
    this.store = new Store()
    this.store.initId(id)
  }
  render() {
    const {
      data: { title, sub_title, content, list_img, list_video }
    } = this.store

    const { path } = list_video || {}

    return (
      <HeaderView title={'商学院'}>
        <div className={styles.wrap}>
          {path && (
            <Fragment>
              <video
                src={path}
                controls
                poster={list_img}
                style={{ width: '100%' }}
              />
              <div className={styles.box}>
                <p className={styles.title}>{title}</p>
                <p className={styles.sub_title}>{sub_title}</p>
              </div>

              <p className={styles.tip}>内容说明</p>
            </Fragment>
          )}

          <div dangerouslySetInnerHTML={{ __html: content }} />
        </div>
      </HeaderView>
    )
  }
}
